import type { ReactNode } from 'react';
import React from 'react';

import { Box } from '@mui/material';

import type { SxProps, Theme } from '@mui/material';

export const InfoBox = ({
  children,
  backgroundColor,
  sx
}: {
  children?: ReactNode;
  sx?: SxProps<Theme>;
  backgroundColor?: string;
}) => {
  return (
    <Box
      sx={[
        theme => ({
          backgroundColor: backgroundColor ?? theme.palette.secondary.main,
          color: theme.palette.text.primary,
          borderLeft: `4px solid ${theme.palette.primary.main}`
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      {children}
    </Box>
  );
};
